import React from "react"
import { Controller } from "react-hook-form"
import MultiSelect from "../../Ui/Form/MultiSelect"
import { ErrorMessage } from "@hookform/error-message"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { ALL_TAX_PROVIDERS } from "../../../graphql/queries/config/Providers/TaxJar/AllTaxProviders"
import { InputUpdateStoreMarket, Provider } from "lib/types/generated/graphql-types"
import { Common } from "lib/types"
import { Control, UseFormSetValue } from "react-hook-form/dist/types/form"
import { FieldErrors } from "react-hook-form/dist/types/errors"

const InputSection = styled.div`
  flex: 1;
  margin-bottom: 2rem;
`

const Label = styled.label`
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-bottom: 0.3rem;
`

type Props = {
  defaultValue: Common.Option[] | undefined
  control: Control
  errors: FieldErrors
  setValue: UseFormSetValue<InputUpdateStoreMarket>
  countryCode: string
}

export const TaxProviders = ({ defaultValue, control, errors, setValue, countryCode }: Props) => {
  const { data } = useQuery(ALL_TAX_PROVIDERS)

  // Only show TaxJar for US store markets
  if (countryCode !== "US") return null

  const taxProviderOptions = data?.getTaxProviders?.map((provider: Provider) => ({
    value: provider.id,
    label: provider.id
  }))

  const updateTaxProviders = (providers: Common.Option[]) =>
    setValue(
      "capabilities.taxProviders",
      providers.map((provider) => ({
        id: provider.value,
        type: data?.getTaxProviders?.find((p: Provider) => p.id === provider.value)?.type
      }))
    )

  // Hide if no tax providers are available
  if (!taxProviderOptions || taxProviderOptions.length === 0) return null

  return (
    <InputSection>
      <Label>Tax providers</Label>
      <Controller
        name="capabilities.taxProviders"
        render={() => (
          <MultiSelect
            defaultValue={defaultValue}
            options={taxProviderOptions}
            setValue={updateTaxProviders}
          />
        )}
        control={control}
      />
      <ErrorMessage errors={errors} name="capabilities.taxProviders" />
    </InputSection>
  )
}

export default TaxProviders
